import React from 'react';
import './Textarea.css';

/**
 * Baustein — Textarea.
 * Mehrzeiliges Feld; gleiche Box-Optik wie Input. resize: vertical.
 *
 * Beispiel:
 *   <Textarea value={text} onChange={(e) => setText(e.target.value)} rows={8} />
 *
 * Props:
 *   invalid — boolean → rote Border
 *   …rest   — alle nativen <textarea>-Props (value, onChange, rows, placeholder, …)
 */
const Textarea = React.forwardRef(function Textarea(
  { invalid = false, className = '', rows = 4, ...rest },
  ref,
) {
  const classes = ['ui-textarea'];
  if (invalid) classes.push('ui-textarea--invalid');
  if (className) classes.push(className);
  return <textarea ref={ref} className={classes.join(' ')} rows={rows} {...rest} />;
});

export default Textarea;
